import argentina from "../assets/images/flags/argentina.jpg";
import australia from "../assets/images/flags/australia.jpg";
import brazil from "../assets/images/flags/brazil.jpg";
import canada from "../assets/images/flags/canada.jpg";
import chile from "../assets/images/flags/chile.jpg";
import england from "../assets/images/flags/england.png";
import fiji from "../assets/images/flags/fiji.jpg";
import france from "../assets/images/flags/france.jpg";
import georgia from "../assets/images/flags/georgia.jpg";
import germany from "../assets/images/flags/germany.jpg";
import ireland from "../assets/images/flags/ireland.jpg";
import italy from "../assets/images/flags/italy.jpg";
import japan from "../assets/images/flags/japan.jpg";
import kenya from "../assets/images/flags/kenya.jpg";
import namibia from "../assets/images/flags/namibia.jpg";
import netherlands from "../assets/images/flags/netherlands.jpg";
import newZealand from "../assets/images/flags/new-zealand.jpg";
import portugal from "../assets/images/flags/portugal.jpg";
import romania from "../assets/images/flags/romania.jpg";
import samoa from "../assets/images/flags/samoa.jpg";
import scotland from "../assets/images/flags/scotland.jpg";
import southAfrica from "../assets/images/flags/south-africa.jpg";
import spain from "../assets/images/flags/spain.jpg";
import tonga from "../assets/images/flags/tonga.jpg";
import usa from "../assets/images/flags/united-states-of-america.jpg";
import uruguay from "../assets/images/flags/uruguay.jpg";
import wales from "../assets/images/flags/wales.jpg";

import barbarians from "../assets/images/logos/solid/barbarians.jpg";

import poland from "../assets/images/flags/poland.jpg";
import czechRepublic from "../assets/images/flags/czech-republic.jpg";
import hongkong from "../assets/images/flags/hong-kong-china.jpg";

import bulls from "../assets/images/rivalry/bulls.jpg";
import stormers from "../assets/images/rivalry/stormers.jpg";
import sharks from "../assets/images/rivalry/sharks.jpg";
import lions from "../assets/images/rivalry/lions.jpg";

/* ==================================================
   URC — MEN 2026/27
   ================================================== */

import urcBenetton from "../assets/images/teams/men/urc/benetton.jpg";
import urcBulls from "../assets/images/teams/men/urc/bulls.jpg";
import urcCardiff from "../assets/images/teams/men/urc/cardiff.jpg";
import urcConnacht from "../assets/images/teams/men/urc/connacht.jpg";
import urcDragons from "../assets/images/teams/men/urc/dragons.jpg";
import urcEdinburgh from "../assets/images/teams/men/urc/edinburgh.jpg";
import urcGlasgowWarriors from "../assets/images/teams/men/urc/glasgow-warriors.jpg";
import urcLeinster from "../assets/images/teams/men/urc/leinster.jpg";
import urcLions from "../assets/images/teams/men/urc/lions.jpg";
import urcMunster from "../assets/images/teams/men/urc/munster.jpg";
import urcOspreys from "../assets/images/teams/men/urc/ospreys.jpg";
import urcScarlets from "../assets/images/teams/men/urc/scarlets.jpg";
import urcSharks from "../assets/images/teams/men/urc/sharks.jpg";
import urcStormers from "../assets/images/teams/men/urc/stormers.jpg";
import urcUlster from "../assets/images/teams/men/urc/ulster.jpg";
import urcZebreParma from "../assets/images/teams/men/urc/zebre-parma.jpg";

/* ==================================================
   GALLAGHER PREM — MEN 2026/27
   ================================================== */

import premBath from "../assets/images/teams/men/gallagher-prem/bath.jpg";
import premBristolBears from "../assets/images/teams/men/gallagher-prem/bristol-bears.jpg";
import premExeterChiefs from "../assets/images/teams/men/gallagher-prem/exeter-chiefs.jpg";
import premGloucester from "../assets/images/teams/men/gallagher-prem/gloucester.jpg";
import premHarlequins from "../assets/images/teams/men/gallagher-prem/harlequins.jpg";
import premLeicesterTigers from "../assets/images/teams/men/gallagher-prem/leicester-tigers.jpg";
import premNewcastleRedBulls from "../assets/images/teams/men/gallagher-prem/newcastle-red-bulls.jpg";
import premNorthamptonSaints from "../assets/images/teams/men/gallagher-prem/northampton-saints.jpg";
import premSaleSharks from "../assets/images/teams/men/gallagher-prem/sale-sharks.jpg";
import premSaracens from "../assets/images/teams/men/gallagher-prem/saracens.jpg";

/* ==================================================
   EPCR CHALLENGE CUP — MEN 2026/27
   ================================================== */

import epcrBayonne from "../assets/images/teams/men/epcr/bayonne.png";
import epcrBenetton from "../assets/images/teams/men/epcr/benetton.jpg";
import epcrBlackLion from "../assets/images/teams/men/epcr/black-lion.png";
import epcrCastres from "../assets/images/teams/men/epcr/castre.png";
import epcrCheetahs from "../assets/images/teams/men/epcr/cheetahs.png";
import epcrDragons from "../assets/images/teams/men/epcr/dragons.jpg";
import epcrEdinburgh from "../assets/images/teams/men/epcr/edinburgh.jpg";
import epcrHarlequins from "../assets/images/teams/men/epcr/harlequins.jpg";
import epcrLyon from "../assets/images/teams/men/epcr/lyon.png";
import epcrNewcastleRedBulls from "../assets/images/teams/men/epcr/newcastle-red-bulls.jpg";
import epcrOspreys from "../assets/images/teams/men/epcr/ospreys.jpg";
import epcrScarlets from "../assets/images/teams/men/epcr/scarlets.jpg";
import epcrSharks from "../assets/images/teams/men/epcr/sharks.jpg";
import epcrToulon from "../assets/images/teams/men/epcr/toulon.png";
import epcrUlster from "../assets/images/teams/men/epcr/ulster.jpg";
import epcrUsap from "../assets/images/teams/men/epcr/usa-perpignan.png";
import epcrVannes from "../assets/images/teams/men/epcr/vannes.png";
import epcrZebreParma from "../assets/images/teams/men/epcr/zebre-parma.jpg";

/* ==================================================
   INVESTEC CHAMPIONS CUP — MEN 2026/27
   ================================================== */

import investecBath from "../assets/images/teams/men/investec/bath.jpg";
import investecBordeauxBegles from "../assets/images/teams/men/investec/bordeaux-begles.png";
import investecBristolBears from "../assets/images/teams/men/investec/bristol-bears.jpg";
import investecBulls from "../assets/images/teams/men/investec/bulls.jpg";
import investecCardiff from "../assets/images/teams/men/investec/cardiff.jpg";
import investecClermontAuvergne from "../assets/images/teams/men/investec/clermont-auvergne.png";
import investecConnacht from "../assets/images/teams/men/investec/connacht.jpg";
import investecExeterChiefs from "../assets/images/teams/men/investec/exeter-chiefs.jpg";
import investecGlasgowWarriors from "../assets/images/teams/men/investec/glasgow-warriors.jpg";
import investecGloucester from "../assets/images/teams/men/investec/gloucester.jpg";
import investecLaRochelle from "../assets/images/teams/men/investec/la-rochelle.png";
import investecLeicesterTigers from "../assets/images/teams/men/investec/leicester-tigers.jpg";
import investecLeinster from "../assets/images/teams/men/investec/leinster.jpg";
import investecLions from "../assets/images/teams/men/investec/lions.jpg";
import investecMontpellier from "../assets/images/teams/men/investec/montpellier.png";
import investecMunster from "../assets/images/teams/men/investec/munster.jpg";
import investecNorthamptonSaints from "../assets/images/teams/men/investec/northampton-saints.jpg";
import investecPau from "../assets/images/teams/men/investec/pau.png";
import investecRacing92 from "../assets/images/teams/men/investec/racing-92.png";
import investecSaleSharks from "../assets/images/teams/men/investec/sale-sharks.jpg";
import investecSaracens from "../assets/images/teams/men/investec/saracens.jpg";
import investecStadeFrancais from "../assets/images/teams/men/investec/stade-francais.png";
import investecStormers from "../assets/images/teams/men/investec/stormers.jpg";
import investecToulouse from "../assets/images/teams/men/investec/toulouse.png";

/* ==================================================
   BUNNINGS NPC — MEN 2026
   ================================================== */

import npcAucklandBlues from "../assets/images/teams/men/npc/auckland-blues.png";
import npcBayOfPlenty from "../assets/images/teams/men/npc/bay-of-plenty.png";
import npcCanterbury from "../assets/images/teams/men/npc/canterbury.png";
import npcCountiesManukau from "../assets/images/teams/men/npc/counties-manukau.png";
import npcHawkesBay from "../assets/images/teams/men/npc/hawkes-bay.png";
import npcManawatu from "../assets/images/teams/men/npc/manawatu.png";
import npcNorthHarbour from "../assets/images/teams/men/npc/north-harbour.png";
import npcNorthland from "../assets/images/teams/men/npc/northland.png";
import npcOtago from "../assets/images/teams/men/npc/otago.png";
import npcSouthland from "../assets/images/teams/men/npc/southland.png";
import npcTaranaki from "../assets/images/teams/men/npc/taranaki.png";
import npcTasman from "../assets/images/teams/men/npc/tasman.png";
import npcWaikato from "../assets/images/teams/men/npc/waikato.png";
import npcWellington from "../assets/images/teams/men/npc/wellington.png";

export const flagMap: Record<string, string> = {
  "argentina": argentina,
  "australia": australia,
  "brazil": brazil,
  "canada": canada,
  "chile": chile,
  "england": england,
  "fiji": fiji,
  "france": france,
  "georgia": georgia,
  "germany": germany,
  "ireland": ireland,
  "italy": italy,
  "japan": japan,
  "kenya": kenya,
  "namibia": namibia,
  "netherlands": netherlands,
  "new-zealand": newZealand,
  "portugal": portugal,
  "romania": romania,
  "samoa": samoa,
  "scotland": scotland,
  "south-africa": southAfrica,
  "spain": spain,
  "tonga": tonga,
  "united-states-of-america": usa,
  "uruguay": uruguay,
  "wales": wales,

  "barbarians": barbarians,

  "poland": poland,
  "czech-republic": czechRepublic,
  "hong-kong-china": hongkong,

  /* ==================================================
     TEMP FIX
     ================================================== */

  "great-britain": england,

  /* ==================================================
     GREATEST RIVALRY
     Existing mappings preserved intentionally.
     ================================================== */

  "bulls": bulls,
  "stormers": stormers,
  "sharks": sharks,
  "lions": lions,

  /* ==================================================
     URC — MEN 2026/27
     ================================================== */

  "urc-benetton": urcBenetton,
  "urc-bulls": urcBulls,
  "urc-cardiff": urcCardiff,
  "urc-connacht": urcConnacht,
  "urc-dragons": urcDragons,
  "urc-edinburgh": urcEdinburgh,
  "urc-glasgow-warriors": urcGlasgowWarriors,
  "urc-leinster": urcLeinster,
  "urc-lions": urcLions,
  "urc-munster": urcMunster,
  "urc-ospreys": urcOspreys,
  "urc-scarlets": urcScarlets,
  "urc-sharks": urcSharks,
  "urc-stormers": urcStormers,
  "urc-ulster": urcUlster,
  "urc-zebre-parma": urcZebreParma,

  /* ==================================================
     GALLAGHER PREM — MEN 2026/27
     ================================================== */

  "prem-bath": premBath,
  "prem-bristol-bears": premBristolBears,
  "prem-exeter-chiefs": premExeterChiefs,
  "prem-gloucester": premGloucester,
  "prem-harlequins": premHarlequins,
  "prem-leicester-tigers": premLeicesterTigers,
  "prem-newcastle-red-bulls": premNewcastleRedBulls,
  "prem-northampton-saints": premNorthamptonSaints,
  "prem-sale-sharks": premSaleSharks,
  "prem-saracens": premSaracens,

  /* ==================================================
     EPCR CHALLENGE CUP — MEN 2026/27
     ================================================== */

  "epcr-bayonne": epcrBayonne,
  "epcr-benetton": epcrBenetton,
  "epcr-black-lion": epcrBlackLion,
  "epcr-castres": epcrCastres,
  "epcr-cheetahs": epcrCheetahs,
  "epcr-dragons": epcrDragons,
  "epcr-edinburgh": epcrEdinburgh,
  "epcr-harlequins": epcrHarlequins,
  "epcr-lou": epcrLyon,
  "epcr-newcastle": epcrNewcastleRedBulls,
  "epcr-ospreys": epcrOspreys,
  "epcr-scarlets": epcrScarlets,
  "epcr-sharks": epcrSharks,
  "epcr-toulon": epcrToulon,
  "epcr-ulster": epcrUlster,
  "epcr-usap": epcrUsap,
  "epcr-vannes": epcrVannes,
  "epcr-zebre": epcrZebreParma,

  /* ==================================================
     INVESTEC CHAMPIONS CUP — MEN 2026/27
     ================================================== */

  "investec-bath": investecBath,
  "investec-bordeaux-begles": investecBordeauxBegles,
  "investec-bristol": investecBristolBears,
  "investec-bulls": investecBulls,
  "investec-cardiff": investecCardiff,
  "investec-clermont": investecClermontAuvergne,
  "investec-connacht": investecConnacht,
  "investec-exeter": investecExeterChiefs,
  "investec-glasgow": investecGlasgowWarriors,
  "investec-gloucester": investecGloucester,
  "investec-la-rochelle": investecLaRochelle,
  "investec-leicester": investecLeicesterTigers,
  "investec-leinster": investecLeinster,
  "investec-lions": investecLions,
  "investec-montpellier": investecMontpellier,
  "investec-munster": investecMunster,
  "investec-northampton": investecNorthamptonSaints,
  "investec-pau": investecPau,
  "investec-racing-92": investecRacing92,
  "investec-sale": investecSaleSharks,
  "investec-saracens": investecSaracens,
  "investec-stade-francais": investecStadeFrancais,
  "investec-stormers": investecStormers,
  "investec-toulouse": investecToulouse,

  /* ==================================================
     BUNNINGS NPC — MEN 2026
     ================================================== */

  "npc-auckland-blues": npcAucklandBlues,
  "npc-bay-of-plenty": npcBayOfPlenty,
  "npc-canterbury": npcCanterbury,
  "npc-counties-manukau": npcCountiesManukau,
  "npc-hawkes-bay": npcHawkesBay,
  "npc-manawatu": npcManawatu,
  "npc-north-harbour": npcNorthHarbour,
  "npc-northland": npcNorthland,
  "npc-otago": npcOtago,
  "npc-southland": npcSouthland,
  "npc-taranaki": npcTaranaki,
  "npc-tasman": npcTasman,
  "npc-waikato": npcWaikato,
  "npc-wellington": npcWellington,
};